import { create } from 'zustand';

export interface Toast {
    id: string;
    type: 'success' | 'error' | 'info';
    message: string;
    duration?: number;
}

interface ToastStore {
    toasts: Toast[];
    add: (toast: Omit<Toast, 'id'>) => void;
    dismiss: (id: string) => void;
}

export const useToastStore = create<ToastStore>((set) => ({
    toasts: [],
    add: (toast) =>
        set((state) => ({
            toasts: [
                ...state.toasts,
                { ...toast, id: `${Date.now()}-${Math.random().toString(36).slice(2)}` },
            ],
        })),
    dismiss: (id) =>
        set((state) => ({
            toasts: state.toasts.filter((t) => t.id !== id),
        })),
}));

// Convenience helpers — import { toast } from '...'
export const toast = {
    success: (message: string, duration?: number) =>
        useToastStore.getState().add({ type: 'success', message, duration }),
    error: (message: string, duration?: number) =>
        useToastStore.getState().add({ type: 'error', message, duration }),
    info: (message: string, duration?: number) =>
        useToastStore.getState().add({ type: 'info', message, duration }),
};
